























































import {
  Vue,
  Component,
  Watch
} from "@/shared/vuepack";

import SettingsNavigation from "@/employee/components/settings/SettingsNavigation.vue";
import Widget from "@/shared/components/Widget.vue";
import Checkbox from "@/shared/components/ui/Checkbox.vue";
import { UserPreferences } from "@/shared/types";
import { formatCurrency } from "@/shared/currency";
import SettingsHeader from "@/employee/components/settings/SettingsHeader.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import HsabPreferences from "@/employee/components/settings/hsaBank/HsabPreferences.vue";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { usePreferencesStore } from "@/employee/store/preferences";

@Component({
  components: {
    SettingsNavigation,
    Widget,
    Checkbox,
    SettingsHeader,
    GenericLoadingSpinner,
    HsabPreferences,
  }
})
export default class UserPreferenceSettings extends Vue {
  custodianSettingsStore = useCustodianSettingsStore();
  preferencesStore = usePreferencesStore();


  mounted () {
    this.custodianSettingsStore.getCustodianSettings();
    if (this.custodianSettingsStore.isHsaBankCustodian === false) {
      this.preferencesStore.loadPreferences();
    }
  }

  get dontSendPaper () {
    return !this.preferencesStore.usePaperStatements;
  }

  get quarterlyPaperStatementFeeString () {
    return `${formatCurrency(this.custodianSettingsStore.quarterlyPaperStatementFee)}`;
  }

  onCheck () {
    const userPreferences: UserPreferences = {
      paperStatement: !this.preferencesStore.usePaperStatements
    };

    this.preferencesStore.setPreferences(userPreferences);
  }
}

